<template>
  <div v-html="content"></div>
</template>

<script>
import { getActivityRuleContent } from "@/api/join";
export default {
  data() {
    return {
      content: "",
    };
  },
  mounted() {
    getActivityRuleContent({ type: "8" }).then((res) => {
      if (res.appStatus.errorCode == 0) {
        this.content = res.content.content;
      }
    });
  },
};
</script>

<style>
</style>